

export default class LiveEvents {
    messageHandlers;

    constructor() {
        this.messageHandlers = {};
    }

    emitSingle(msgType, msgData) {
        const handlers = this.messageHandlers[msgType] || [];
        handlers.forEach(handler => {
            handler(msgData);
        });
    }

    emitWildcard(msgData) {
        const handlers = this.messageHandlers['*'] || [];
        handlers.forEach(handler => {
            handler(msgData);
        });
    }

    emit(msgType, msgData) {
        this.emitSingle(msgType, msgData);
        this.emitWildcard(msgData);
    }

    on(msgType, callback) {
        if (!this.messageHandlers[msgType]) {
            this.messageHandlers[msgType] = [callback];
        } else {
            this.messageHandlers[msgType].push(callback);
        }
    }

    once(msgType, callback) {
        const wrapper = (data) => {
            this.off(msgType, wrapper);
            callback(data);
        };
        this.on(msgType, wrapper);
    }

    ignoreAll(msgType) {
        delete this.messageHandlers[msgType];
    }

    // --- Extensions for cleanup ---

    off(msgType, callback) {
        if (!this.messageHandlers[msgType]) return;
        this.messageHandlers[msgType] = this.messageHandlers[msgType].filter(
            cb => cb !== callback
        );
    }

    removeAllListeners(msgType) {
        if (msgType) {
            delete this.messageHandlers[msgType];
        } else {
            this.messageHandlers = {};
        }
    }
}
